import React, { useEffect, useState } from "react";
import ProductList from "../../components/AdvanceDynamicList/ProductList";
import { getStoredData } from "../../json/fecthData";
import { getUser, hasPermission } from "../../pages/Login/authUtils";
import axios from "axios";

const MasterTrackerPanel = () => {
  const data = getStoredData()?.[1] || {};

  const TitleMasterTracker = data.TitleMasterTracker || "MasterTracker";
  const AdminMasterTracker = data.AdminMasterTracker || [];
  const RedirectAdminMasterTracker = data.RedirectAdminMasterTracker;
  const ApiMasterTracker = data.ApiMasterTracker;
  const roleCompare = data.roleCompare || [];
  const StatusMasterTracker = data.MasterTrackerStatus || [];
  const ApiMasterTrackerGet = data.ApiMasterTrackerGet || [];


  const [masterTrackerItems, setMasterTrackerItems] = useState([]);

  const canDelete = hasPermission("tracker:delete");
  const canUpload = hasPermission("tracker:upload");
  const canDownload = hasPermission("tracker:download");

  const user = getUser();

  // 🔁 Fetch populated data from /details
  useEffect(() => {
    const fetchMasterTracker = async () => {
      try {
        const res = await axios.get(`${ApiMasterTracker}`);
        if (Array.isArray(res.data)) {
          setMasterTrackerItems(res.data);
        }
      } catch (err) {
        console.error("Error fetching mastertracker details:", err);
      }
    };

    fetchMasterTracker();
  }, [ApiMasterTracker]);

  return (
    <div className="MasterTrackerPanel">
      <h1>{TitleMasterTracker} Management</h1>
      <ProductList
        products={masterTrackerItems}
        setProducts={setMasterTrackerItems}
        fields={AdminMasterTracker}
        redirect={RedirectAdminMasterTracker}
        deleteApi={ApiMasterTracker}
        getApi={ApiMasterTrackerGet}
        roleCompare={roleCompare}
        createPath={hasPermission("MasterTracker:create") ? "/tracker/create" : null}
        showDelete={canDelete}
        showUpload={canUpload}
        showDownload={canDownload}
        status={StatusMasterTracker}
        title={TitleMasterTracker}

      />
    </div>
  );
};

export default MasterTrackerPanel;
